import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule, DirectivesModule } from '@huge-monorepo/shared/modules';
import { ToolsModule } from '@huge-monorepo/shared/tools';
import { Form, FormControl, FormGroup, Validators } from '@angular/forms';
import { ICustomerGenericService, IHIPGenericService, TeltonikaFileData, TeltonikaSNMPAgentSettings, TeltonikaSNMPGeneralSettings } from '@huge-monorepo/shared/interfaces';
import { ActivatedRoute } from '@angular/router';
import { TableAction, TableHeader } from '@huge-monorepo/shared/interfaces';
import { SharedTeltonikaSingletonService, DialogService, SharedGenericSingletonService } from '@huge-monorepo/shared/services';
import { IHIPTeltonikaService, ICustomerTeltonikaService } from '@huge-monorepo/shared/interfaces';
import { MatDialog } from '@angular/material/dialog';
import { TeltonikaConfirmUploadModalComponent } from '../../modals/teltonika-confirm-upload-modal/teltonika-confirm-upload-modal.component';
import { YesNoModalComponent } from '@huge-monorepo/shared/tools';
import { CreateTeltonikaSNMPUser, GetTeltonikaSNMPUser, UpdateTeltonikaSNMPUser } from 'libs/shared/src/interfaces/TeltonikaSNMPUser';
import { TeltonikaEditSnmpUserModalComponent } from '../../modals/teltonika-edit-snmp-user-modal/teltonika-edit-snmp-user-modal.component';
@Component({
  selector: 'huge-monorepo-teltonika-device-other-services',
  standalone: true,
  imports: [CommonModule, MaterialModule, ToolsModule],
  templateUrl: './teltonika-device-other-services.component.html',
  styleUrl: './teltonika-device-other-services.component.scss',
})
export class TeltonikaDeviceOtherServicesComponent implements OnInit {
  teltonikaService = this.sharedTeltonikaService.getService();
  isHIP = this.sharedTeltonikaService.getIsHIP();
  generatedFilesUrl = ``;
  configFilesUrl = "/teltonika/config/list";
  genericService = this.genericServiceSingleton.getGenericService();
  snmpAgentLoading: boolean = false;
  snmpGeneralLoading: boolean = false;
  snmpUserLoading: boolean = false;
  wanLoading: boolean = false;

  backupFilesHeaders: TableHeader[] = [
    {
      ID: 'Name',
      Index: 0,
      Sort: 'Name',
      Sortable: false,
      Text: 'Name',
      Type: String,
      Align: 'left',
    },
    {
      ID: "Type",
      Index: 1,
      Sort: "Type",
      Sortable: false,
      Text: "Type",
      Type: String,
      Align: "left"
    },
    {
      ID: "Timestamp",
      Index: 2,
      Sort: "Timestamp",
      Sortable: false,
      Text: "Timestamp",
      Type: Date,
      Align: 'left'
    }
  ];
  backupTableActions: TableAction[] = [
    {
      Icon: 'download',
      Text: 'Download',
      Caller: (p: TeltonikaFileData) => {
        if (p != null) {
          this.downloadBackupFiles(p.ID);
        }
      },
    },
  ];

  configFilesHeaders: TableHeader[] = [
    {
      ID: 'Name',
      Index: 0,
      Sort: 'Name',
      Sortable: false,
      Text: 'Name',
      Type: String,
      Align: 'left',
    },
    {
      ID: "Type",
      Index: 1,
      Sort: "Type",
      Sortable: false,
      Text: "Type",
      Type: String,
      Align: "left"
    },
    {
      ID: "Timestamp",
      Index: 2,
      Sort: "Timestamp",
      Sortable: false,
      Text: "Timestamp",
      Type: Date,
      Align: 'left'
    }
  ];
  configFilesActions: TableAction[] = [
    {
      Icon: 'publish',
      Text: 'Apply',
      Caller: (p: TeltonikaFileData) => {
        if (p != null) {
          this.applyConfigFile(p.ID, p.Type);
        }
      },
    },
  ];
  loading: boolean = false;
  id: number;
  backupFileData: TeltonikaFileData[];
  opn: string = '';
  constructor(
    private sharedTeltonikaService: SharedTeltonikaSingletonService<ICustomerTeltonikaService | IHIPTeltonikaService>,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
    private dialogService: DialogService,
    private genericServiceSingleton: SharedGenericSingletonService<ICustomerGenericService | IHIPGenericService>) { }

  isFileUploaded?: boolean;
  working: boolean = false;
  files?: FileList | null = null;
  form = new FormGroup({
    fileNameControl: new FormControl('', [Validators.required]),
    confirmed: new FormControl(false),
  });
  smsMessage: string | null = null;
  snmpSettingsForm: FormGroup = new FormGroup({
    enabled: new FormControl(false),
    remoteAccess: new FormControl(false),
    ipType: new FormControl('ipv4'),
    port: new FormControl(null, [Validators.required, Validators.min(1), Validators.max(65535)]),
    v1Mode: new FormControl(false),
    v2cMode: new FormControl(false),
    v3Mode: new FormControl(false),
  });
  snmpSettingsFetched: boolean = false;
  snmpAgentError: string | null = null;
  snmpGeneralError: string | null = null;
  snmpGeneralFetched: boolean = false;
  snmpGeneralForm: FormGroup = new FormGroup({
    location: new FormControl(''),
    contact: new FormControl(''),
    name: new FormControl(''),
  });

  snmpUsers: UpdateTeltonikaSNMPUser[] | null = null;
  snmpUserFetched: boolean = false;

  wanDataSchedulingFetched: boolean = false;

  wanForm: FormGroup = new FormGroup({
    enabled: new FormControl(false),
    interval: new FormControl(null, [Validators.required, Validators.min(60)]),
  });

  firmwareForm: FormGroup = new FormGroup({
    fileNameControl: new FormControl('', [Validators.required]),
    confirmed: new FormControl(false),
  });
  firmwareFiles: FileList | null = null;
  isFirmwareFileUploaded: boolean = false;
  firmwareWorking: boolean = false;
  applyFirmwareLoading: boolean = false;
  firmwareFilesURL: string;
  firmwareFileHeaders: TableHeader[] = [
    { ID: 'Name', Index: 0, Sort: 'Name', Sortable: false, Text: 'Name', Type: String, Align: 'left' },
    { ID: 'Timestamp', Index: 1, Sort: 'Timestamp', Sortable: false, Text: 'Timestamp', Type: Date, Align: 'left' }
  ]

  firmwareFileActions: TableAction[] = [
    {
      Icon: 'publish',
      Text: 'Apply',
      Caller: (p: TeltonikaFileData) => {
        if (p != null) {
          this.applyFirmwareFile(p.ID);
        }
      },
      Validator: (p: TeltonikaFileData) => {
        return p.Applicable;
      }
    },
  ]

  ngOnInit(): void {
    this.loading = true;
    this.activatedRoute.paramMap.subscribe(
      (paraMap: any) => {
        if (paraMap.params.id) {
          this.id = paraMap.params.id;
          this.generatedFilesUrl = `/teltonika/${this.id}/generated`;
          this.firmwareFilesURL = `/teltonika/${this.id}/firmware`;
        }
        // this.fetchBackupFiles();
        this.loading = false;
      }
    );
    if (!this.isHIP) {
      this.configFilesActions = []
    }
  }

  downloadBackupFiles(id: number) {
    this.teltonikaService.downloadTeltonikaFile(id).subscribe(
      {
        next: (data) => {
          return;
        },
        error: (error) => {
          this.genericService.createToast('Error', 'Failed to download backup file', 'error');
        }
      }
    );
  }

  generateBackupFile() {
    this.loading = true;
    this.teltonikaService.generateFile(this.id, "backup").subscribe(
      {
        next: (data) => {
          this.opn = "&opn=true"
          this.loading = false;
        },
        error: (error) => {
          this.genericService.createToast('Error', 'Failed to generate backup file', 'error');
          this.loading = false;
        }
      }
    );
  }

  applyConfigFile(configId: number, type: string) {
    this.teltonikaService.applyConfigFile(this.id, configId, type).subscribe({
      next: () => {
        this.genericService.createToast("Success", "Config file successfully applied", "success");
      },
      error: (err) => {
        this.genericService.createToast("Error", "Error applying file", "error");
      }
    });
  }

  handleDroppedFiles(files) {
    let input = document.getElementById('fileInput') as HTMLInputElement;
    if (input != null) {
      this.onFileInput(files);
    }
  }

  onFileInput(files: FileList | null) {
    if (files == null || files.length === 0) {
      this.genericService.createToast('Error', 'Please select a file to upload', 'error');
      return;
    }
    if (this.working) {
      this.genericService.createToast('Busy Uploading', 'You cannot change the file list whilst uploading. Please wait for the current process to finish', 'error');
      return;
    }

    if (files.length === 1) {
      if (!files[0].name.endsWith('.tar.gz')) {
        this.genericService.createToast('Error', 'Please select a .tar.gz file', 'error');
        return;
      }
      this.files = files;
      this.isFileUploaded = true;
      return;
    } else {
      this.genericService.createToast('Error', 'Please select only one file', 'error');
      return;
    }
  }

  deleteFile() {
    this.files = null;
    this.isFileUploaded = false;
  }

  upload() {

    if (this.working) {
      this.genericService.createToast('Busy Uploading', 'You cannot change the file list whilst uploading. Please wait for the current process to finish', 'error');
      return;
    }
    if (this.files == null || this.files.length === 0) {
      this.genericService.createToast('Error', 'Please select a file to upload', 'error');
      return;
    } else if (this.form.invalid) {
      this.genericService.createToast('Error', 'Please enter a file name', 'error');
      return;
    }

    const dialogRef = this.dialog.open(TeltonikaConfirmUploadModalComponent, {
      width: '800px',
      maxHeight: '60vh',
      data: { fileName: this.form.get("fileNameControl")?.value || "" }
    });
    this.dialogService.RegisterDialog(dialogRef);
    dialogRef.afterClosed().subscribe((result) => {
      this.dialogService.DeRegisterDialog(dialogRef);
      if (result !== null) {
        if (result != false) {

          this.working = true;

          this.teltonikaService.uploadConfigFile(this.id, this.files, this.form.get("fileNameControl")?.value || "").subscribe({
            next: (resp) => {
              this.genericService.createToast("Uploaded", "File uploaded successfully", "success");
            },
            error: (err) => {
              this.genericService.createToast("Error Uploading", "There was an error Uploading your file", "error");
              console.error(err);
            },
            complete: () => {
              this.working = false;
            }
          });
        }
      }
    });
    return;
  }

  sendSMS(simType: 'active' | 'inactive' | 'both') {
    if (this.smsMessage == null || this.smsMessage == "") {
      this.genericService.createToast("Error", "Please enter a message", "error");
      return;
    }
    this.teltonikaService.sendSMS(this.id, this.smsMessage, simType).subscribe({
      next: () => {
        this.genericService.createToast("Success", "SMS sent successfully", "success");
      },
      error: (err) => {
        this.genericService.createToast("Error", "Error sending SMS", "error");
      }
    });
  }

  sendSMSWithConfirmation(simType: 'active' | 'inactive' | 'both') {
    if (this.smsMessage == null || this.smsMessage == "") {
      this.genericService.createToast("Error", "Please enter a message", "error");
      return;
    }
    const dialogRef = this.dialog.open(YesNoModalComponent, { data: { Heading: "Send SMS", Message: "Are you sure you would like to send this SMS to both sims" } });
    this.dialogService.RegisterDialog(dialogRef);
    dialogRef.afterClosed().subscribe((result) => {
      this.dialogService.DeRegisterDialog(dialogRef);

      if (result !== null && result == true) {
        this.teltonikaService.sendSMS(this.id, this.smsMessage, simType).subscribe({
          next: () => {
            this.genericService.createToast("Success", "SMS sent successfully", "success");
          },
          error: (err) => {
            this.genericService.createToast("Error", "Error sending SMS", "error");
          }
        });

      }
    });
  }

  getSNMPAgentSettings() {
    this.snmpAgentLoading = true;
    this.teltonikaService.getTeltonikaSNMPAgentConfig(this.id).subscribe({
      next: (data: TeltonikaSNMPAgentSettings) => {
        this.snmpSettingsForm.patchValue({
          enabled: data.Enabled,
          remoteAccess: data.RemoteAccess,
          ipType: data.IPType,
          port: data.Port,
          v1Mode: data.V1Mode,
          v2cMode: data.V2CMode,
          v3Mode: data.V3Mode
        });
        this.snmpAgentLoading = false;
      },
      error: (err) => {
        if (!err.error.message.includes("SNMP agent settings response HTTP code is not 200")) {
          this.genericService.createToast("Error", "Error fetching SNMP Agent settings", "error");
        }
        this.snmpAgentError = err.error.message;
        this.snmpAgentLoading = false;
      }
    });
  }

  saveSNMPSettings() {
    if (this.snmpSettingsForm.invalid) {
      this.genericService.createToast("Error", "Please fill in all required fields", "error");
      return;
    }
    const snmpSettings: TeltonikaSNMPAgentSettings = {
      Enabled: this.snmpSettingsForm.get('enabled')?.value,
      RemoteAccess: this.snmpSettingsForm.get('remoteAccess')?.value,
      IPType: this.snmpSettingsForm.get('ipType')?.value,
      Port: this.snmpSettingsForm.get('port')?.value,
      V1Mode: this.snmpSettingsForm.get('v1Mode')?.value,
      V2CMode: this.snmpSettingsForm.get('v2cMode')?.value,
      V3Mode: this.snmpSettingsForm.get('v3Mode')?.value,
    };
    this.snmpAgentLoading = true;
    this.teltonikaService.updateTeltonikaSNMPAgentConfig(this.id, snmpSettings).subscribe({
      next: () => {
        this.genericService.createToast("Success", "SNMP settings updated successfully", "success");
        setTimeout(() => {
          this.getSNMPAgentSettings();
        }, 3000);
      },
      error: (err) => {
        this.snmpAgentLoading = false;
        this.genericService.createToast("Error", "Error updating SNMP settings", "error");
      }
    });
  }

  getSNMPGeneralSettings() {
    this.snmpGeneralLoading = true;
    this.teltonikaService.getTeltonikaSNMPGeneralConfig(this.id).subscribe({
      next: (data: TeltonikaSNMPGeneralSettings) => {
        this.snmpGeneralForm.patchValue({
          location: data.Location || '',
          contact: data.Contact || '',
          name: data.Name || ''
        });
        this.snmpGeneralLoading = false;
      },
      error: (err) => {
        if (!err.error.message.includes("SNMP general settings response HTTP code is not 200")) {
          this.genericService.createToast("Error", "Error fetching SNMP General settings", "error");
        }
        this.snmpGeneralError = err.error.message;
        this.snmpGeneralLoading = false;
      }
    });
  }

  saveSNMPGeneralSettings() {
    if (this.snmpGeneralForm.invalid) {
      this.genericService.createToast("Error", "Please fill in all required fields", "error");
      return;
    }
    const snmpSettings: TeltonikaSNMPGeneralSettings = {
      Location: this.snmpGeneralForm.get('location')?.value,
      Contact: this.snmpGeneralForm.get('contact')?.value,
      Name: this.snmpGeneralForm.get('name')?.value,
    };
    this.snmpGeneralLoading = true;
    this.teltonikaService.updateTeltonikaSNMPGeneralConfig(this.id, snmpSettings).subscribe({
      next: () => {
        this.genericService.createToast("Success", "SNMP settings updated successfully", "success");
        this.snmpGeneralLoading = false;
        //Wait 3 secs then fetch
        setTimeout(() => {
          this.getSNMPGeneralSettings();
        }, 3000);
      },
      error: (err) => {
        this.snmpGeneralLoading = false;
        this.genericService.createToast("Error", "Error updating SNMP settings", "error");
      }
    });
  }

  getSNMPUsers() {
    this.snmpUserLoading = true;
    this.teltonikaService.getTeltonikaSNMPUsers(this.id).subscribe({
      next: (data: GetTeltonikaSNMPUser) => {
        if (data != null) {
          console.log(data);

          this.snmpUsers = data.Users;
        } else {
          this.snmpUsers = [];
        }
        this.snmpUserLoading = false;
      },
      error: (err) => {
        if (!err.error.message.includes("SNMP users response HTTP code is not 200")) {
          this.genericService.createToast("Error", "Error fetching SNMP Users", "error");
        }
        this.snmpUserLoading = false;
      }
    });
  }

  snmpUsersOpened() {
    if (!this.snmpUserFetched) {
      this.snmpUserFetched = true;
      this.getSNMPUsers();
    }
  }

  snmpGeneralOpened() {
    if (!this.snmpGeneralFetched) {
      this.snmpGeneralFetched = true;
      this.getSNMPGeneralSettings();
    }
  }

  snmpAgentOpened() {
    if (!this.snmpSettingsFetched) {
      this.snmpSettingsFetched = true;
      this.getSNMPAgentSettings();
    }
  }

  editSNMPUser(user: UpdateTeltonikaSNMPUser) {
    const dialogRef = this.dialog.open(TeltonikaEditSnmpUserModalComponent, {
      width: '50vw',
      data: user
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.snmpUserLoading = true;
        this.teltonikaService.updateTeltonikaSNMPUser(this.id, result as UpdateTeltonikaSNMPUser).subscribe({
          next: () => {
            this.genericService.createToast("Success", "SNMP User updated successfully", "success");
            //Wait 3 secs then fetch
            setTimeout(() => {
              this.getSNMPUsers();
            }, 3000);
          },
          error: (err) => {
            this.snmpUserLoading = false;
            this.genericService.createToast("Error", "Error updating SNMP User", "error");
          }
        });
      }
    });
  }

  addSNMPUser() {
    const dialogRef = this.dialog.open(TeltonikaEditSnmpUserModalComponent, {
      width: '50vw',
      data: null
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.snmpUserLoading = true;
        this.teltonikaService.createTeltonikaSNMPUser(this.id, result as CreateTeltonikaSNMPUser).subscribe({
          next: () => {
            this.genericService.createToast("Success", "SNMP User updated successfully", "success");
            //Wait 3 secs then fetch
            setTimeout(() => {
              this.getSNMPUsers();
            }, 3000);
          },
          error: (err) => {
            this.snmpUserLoading = false;
            this.genericService.createToast("Error", "Error updating SNMP User", "error");
          }
        });
      }
    });
  }

  wanDataSchedulingOpened() {
    if (!this.wanDataSchedulingFetched) {
      this.wanDataSchedulingFetched = true;
      this.getWANScheduler();
    }
  }

  saveWANScheduler() {
    if (this.wanForm.invalid) {
      this.genericService.createToast("Error", "Please fill in all required fields", "error");
      return;
    }
    this.wanLoading = true;
    this.teltonikaService.updateTeltonikaDeviceWANScheduler(this.id, this.wanForm.get("enabled")?.value, this.wanForm.get("interval")?.value).subscribe({
      next: () => {
        this.genericService.createToast("Success", "WAN Scheduler settings updated successfully", "success");
        this.getWANScheduler();
      }
      ,
      error: (err) => {
        this.genericService.createToast("Error", "Error updating WAN Scheduler settings", "error");
        this.wanLoading = false;
      }
    });
  }

  getWANScheduler() {
    this.wanLoading = true;
    this.teltonikaService.getTeltonikaDeviceWANScheduler(this.id).subscribe({
      next: (data) => {
        if (data) {
          this.wanForm.patchValue({
            enabled: data.Enabled || false,
            interval: data.Interval,
          });
        }
        this.wanLoading = false;
      },
      error: (err) => {
        this.genericService.createToast("Error", "Error fetching WAN Scheduler settings", "error");
      }
    });
  }

  applyFirmwareFile(firmwareId: number) {
    this.applyFirmwareLoading = true;
    this.teltonikaService.applyTeltonikaDeviceFirmware(this.id, firmwareId).subscribe({
      next: () => {
        this.genericService.createToast("Success", "Firmware file successfully applied", "success");
        this.applyFirmwareLoading = false;
      },
      error: (err) => {
        this.genericService.createToast("Error", "Error applying firmware file", "error");
        this.applyFirmwareLoading = false;
      },

    });
  }
}
